/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyersectiontext2Inputs */

const en_flyersectiontext2 = /** @type {(inputs: Flyersectiontext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

const de_flyersectiontext2 = /** @type {(inputs: Flyersectiontext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

/**
* | output |
* | --- |
* | "Text" |
*
* @param {Flyersectiontext2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyersectiontext2 = /** @type {((inputs?: Flyersectiontext2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyersectiontext2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyersectiontext2(inputs)
	return de_flyersectiontext2(inputs)
});
export { flyersectiontext2 as "flyerSectionText" }